// Newslettersignup

import './index.scss';

export default class NewsletterSignup {
  constructor(root) {
    this.root = root;

    this.initNewsletterSignup();
  }

  initNewsletterSignup() {
    let form = this.root.querySelector('.newsletter-signup-form');

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const button = form.querySelector('.button-submit');
      button.disabled = true;
      button.classList.add('loading');

      const errors = form.querySelectorAll('.errors');
      errors.forEach(error => {
        error.remove();
      });

      const formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (data.status == 'ok') {
          button.classList.remove('loading');

          form.remove();
          const success = this.root.querySelector('.success');
          success.style.display = 'flex';
        } else {
          for (const elementId in data.messages) {
            const element = document.getElementById(elementId);
            if (element) {
              let div = document.createElement("div");
              div.classList.add('errors');
              for (const i in data.messages[elementId]) {
                const error = data.messages[elementId][i];
                let span = document.createElement("span");
                span.append(error);
                div.append(span);
              }
              element.parentNode.after(div);
            }
          }

          button.classList.remove('loading');
          button.disabled = false;
        }
      });
    });
  }
}
